/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportType } from './reportType';


export interface AccountReportApiModel { 
    guid: string;
    reportType: ReportType;
    dateCreated: string;
    note: string;
}
export namespace AccountReportApiModel {
}


